import { render, staticRenderFns } from "./PreviewV2.vue?vue&type=template&id=58686662&scoped=true&"
import script from "./PreviewV2.vue?vue&type=script&lang=js&"
export * from "./PreviewV2.vue?vue&type=script&lang=js&"
import style0 from "./PreviewV2.vue?vue&type=style&index=0&id=58686662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58686662",
  null
  
)

export default component.exports